import React, { useState, useEffect, useCallback } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import debounce from 'lodash.debounce';
import axios from 'axios';
import {AppBar, IconButton, TextField} from "@mui/material";
import {defaultVariables} from "../../../../../config";
import RayaField from "../../../../components/elements/fields/RayaField";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import Grid from "@mui/material/Grid2";
import {useTranslation} from "react-i18next";
import {Search,X} from "lucide-react";

const ListFilters = ({ onFilter,filters,classes,inner_item,has_bg }) => {
    const { t } = useTranslation();

    const [searchText, setSearchText] = useState('');
    const [industries, setIndustries] = useState([]);
    const [selectedIndustry, setSelectedIndustry] = useState('');
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    useEffect(() => {

        const fetchIndustries = async () => {
            try {
                const response = await axios.get(`${defaultVariables.url}/industries/get-all`,config);
                const industryList = response.data;
                setIndustries(industryList);
                if(filters.includes('all')){
                    setSelectedIndustry('all')
                }else if (industryList.length > 0) {
                    setSelectedIndustry(industryList[0].id);
                }
            } catch (error) {
                console.error('Error fetching industries:', error);
            }
        };

        fetchIndustries();
    }, []);

    // Debounce function to delay sending the search text
    const debouncedSearch = useCallback(
        debounce((text) => {
            onFilter({ text, industry: selectedIndustry });
        }, 500), // 500ms debounce time
        [onFilter, selectedIndustry]
    );

    const handleSearchChange = (event) => {
        const text = event.target.value;
        setSearchText(text);
        debouncedSearch(text); // Pass input value to the debounced function
    };
    const handleClearSearch = () => {
        setSearchText("");
        debouncedSearch("");
    };

    const handleIndustrySelect = (industryId) => {
        setSelectedIndustry(industryId);
        onFilter({ text: searchText, industry: industryId });
    };

    // Cleanup debounce on unmount
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    return (
        <AppBar className={(!!filters.includes('industries') || !!inner_item || !!has_bg) ? classes.panelAppBar : classes.panelAppBarOnlyOne} position="static" color="gray">
            <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                <Grid item size={{xs:12,md:6, lg:4}}>
                    {
                        !!filters.includes('industries') &&
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap'}}>
                            {
                                !!filters.includes('all') &&
                                <Button
                                    color="primary"
                                    variant={selectedIndustry === "all" ? 'contained' : 'outlined'}
                                    onClick={() => handleIndustrySelect("all")}
                                >
                                    {t("all")}
                                </Button>
                            }
                            {industries.map((industry) => (
                                <Button
                                    key={industry.id}
                                    color="primary"
                                    variant={selectedIndustry === industry.id ? 'contained' : 'outlined'}
                                    onClick={() => handleIndustrySelect(industry.id)}
                                >
                                    {t(industry.name)}
                                </Button>
                            ))}
                        </Box>
                    }
                    {
                        inner_item
                    }
                </Grid>
                <Grid item size={{xs:12,md:6, lg:4}}>
                    {
                        !!filters.includes('search') &&
                        <RayaField
                            placeholder={t('search')}
                            variant="outlined"
                            fullWidth
                            value={searchText}
                            onChange={handleSearchChange}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {
                                                !searchText ?
                                                    <Search />
                                                    :
                                                    <IconButton onClick={() => handleClearSearch()}>
                                                        <X/>
                                                    </IconButton>

                                            }
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                    }
                </Grid>
            </Grid>


        </AppBar>
    );
};
export default withStyles(Styles)(ListFilters);
